import styled from 'styled-components';
const FixedWidthEnrollmentFilterWrapper = styled.div.withConfig({
  displayName: "FixedWidthEnrollmentFilterWrapper",
  componentId: "sc-7vqm48-0"
})(["width:350px;"]);
export default FixedWidthEnrollmentFilterWrapper;